(function (window) {
  'use strict';

  var eligibilityPromise = null;

  function isQuotaLimit(error) {
    return Boolean(
      error
      && (
        error.errorCode === 'UPLOAD_QUOTA_EXCEEDED'
        || error.code === 'UPLOAD_QUOTA_EXCEEDED'
        || error.statusCode === 429
        || error.status === 429
      )
    );
  }

  function modalConfig(unified) {
    var modal = document.querySelector(unified ? '[data-stackhouse-modal]' : '[data-stackhouse-modal][data-modal-upload-v2-enabled="true"]');
    if (!modal) return null;
    return {
      session: modal.getAttribute('data-modal-upload-v2-session') || 'Preparing secure upload.',
      transfer: modal.getAttribute('data-modal-upload-v2-transfer') || 'Sending file to Stackhouse storage.',
      progress: modal.getAttribute('data-modal-upload-v2-progress') || 'Uploading file, __PERCENT__%.',
      retry: modal.getAttribute('data-modal-upload-v2-retry') || 'Connection interrupted. Retrying part __PART__ (__ATTEMPT__/3)...',
      processing: modal.getAttribute('data-modal-upload-v2-processing') || 'Upload complete. Preparing your reusable preview.',
      failed: modal.getAttribute('data-modal-upload-v2-failed') || 'The upload could not be completed. Please choose the file again.'
    };
  }

  function emit(eventName, details) {
    var resilience = window.StackhouseUploadResilience;
    if (!resilience || typeof resilience.emit !== 'function') return;
    resilience.emit(eventName, buildCustomizerTrackingPayload(details || {}));
  }

  function prepare(controller) {
    if (!eligibilityPromise) {
      eligibilityPromise = controller.prepare({ apiBaseUrl: api_domain })
        .then(function () { return { available: true }; })
        .catch(function (error) {
          if (isQuotaLimit(error)) {
            return { available: false, quotaLimited: true, error: error };
          }
          emit('file_upload_v2_fallback', {
            upload_pipeline: 'upload_v2',
            failure_phase: 'eligibility',
            error_code: error && (error.errorCode || error.code) || 'UPLOAD_V2_NOT_AVAILABLE',
            status_code: error && (error.statusCode || error.status)
          });
          return { available: false, quotaLimited: false, error: error };
        });
    }
    return eligibilityPromise;
  }

  function handleQuotaLimit(error, uploadAttemptId) {
    ErrorPopupModule.showError(
      error && error.message
        || 'You have reached the upload limit for the last 24 hours. Try again after earlier uploads leave the window.',
      error && error.helpLink
    );
    emit('file_upload_v2_quota_blocked', {
      upload_pipeline: 'upload_v2',
      upload_attempt_id: uploadAttemptId,
      failure_phase: uploadAttemptId ? 'upload_v2' : 'eligibility',
      error_code: error && (error.errorCode || error.code) || 'UPLOAD_QUOTA_EXCEEDED',
      status_code: error && (error.statusCode || error.status) || 429,
      retryable: Boolean(error && error.retryable)
    });
  }

  function updateStatus(uniqueIdentifier, text) {
    var status = document.querySelector(
      '[data-unique-id="' + uniqueIdentifier + '"] .media .inn__loading>p'
    );
    if (status) status.textContent = text;
  }

  function updateProgress(uniqueIdentifier, percent) {
    var container = document.querySelector('[data-unique-id="' + uniqueIdentifier + '"]');
    if (!container) return;
    var bar = container.querySelector('.overlay-progress');
    if (bar) bar.style.height = String(100 - percent) + '%';
  }

  async function upload(file) {
    var controller = window.StackhouseUploadV2;
    var unified;
    try { unified = controller && typeof controller.unifiedAvailable === 'function' && await controller.unifiedAvailable(); }
    catch (error) { ErrorPopupModule.showError(error.message, error.helpLink); return true; }
    var copy = modalConfig(unified);
    if (
      !copy ||
      !controller ||
      typeof controller.prepare !== 'function' ||
      typeof controller.upload !== 'function' ||
      typeof controller.customerAccessReady !== 'function' ||
      (!unified && !controller.customerAccessReady())
    ) {
      return false;
    }
    var eligibility = await prepare(controller);
    if (!eligibility.available) {
      if (eligibility.quotaLimited || unified) {
        handleQuotaLimit(eligibility.error);
        return true;
      }
      return false;
    }

    var policy = window.StackhouseUploadPolicy;
    if (policy && typeof policy.renderDetectedNotices === 'function') policy.renderDetectedNotices({notices: []});
    var validation = policy && typeof policy.validateFile === 'function'
      ? await policy.validateFile(file)
      : { valid: false, error: copy.failed };
    var input = document.querySelector('.form__wrapper .upload__photos>input');
    if (input) input.value = '';
    if (!validation.valid) {
      ErrorPopupModule.showError(validation.error || copy.failed, validation.help_link);
      return true;
    }

    uploadAttemptSequence += 1;
    var uploadAttemptId = uploadAttemptSequence;
    var tempUniqueId = 'upload-v2-' + Math.random().toString(36).slice(2);
    var uploadResilience = window.StackhouseUploadResilience;
    TrackingModule.trackFileUpload(file, uploadAttemptId);
    UIHelpers.adding_file(file, tempUniqueId);

    try {
      var result;
      try {
        result = await controller.upload({
          apiBaseUrl: api_domain,
          file: file,
          uploadSurface: 'classic_modal',
          eventDetails: buildCustomizerTrackingPayload({
            source: 'product_modal_upload_v2',
            upload_pipeline: 'upload_v2',
            upload_attempt_id: uploadAttemptId
          }),
          onStage: function (stage) {
            updateStatus(
              tempUniqueId,
              stage === 'processing' ? copy.processing : stage === 'transfer' ? copy.transfer : copy.session
            );
          },
          onProgress: function (percent) {
            updateProgress(tempUniqueId, percent);
            updateStatus(tempUniqueId, copy.progress.replace('__PERCENT__', String(percent)));
          },
          onRetry: function (partNumber, attempt) {
            updateStatus(
              tempUniqueId,
              copy.retry
                .replace('__PART__', String(partNumber))
                .replace('__ATTEMPT__', String(attempt))
            );
          },
          onProcessing: function (asset) {
            updateStatus(tempUniqueId, controller.processingMessage ? controller.processingMessage(asset) : copy.processing);
          }
        });
      } catch (error) {
        if (!error || !error.retryable || !error.assetId || typeof controller.retryProcessing !== 'function') {
          throw error;
        }
        updateStatus(tempUniqueId, copy.processing);
        emit('file_upload_processing_retry_started', {
          upload_pipeline: 'upload_v2',
          upload_attempt_id: uploadAttemptId,
          upload_asset_id: error.assetId
        });
        result = await controller.retryProcessing({
          apiBaseUrl: api_domain,
          assetId: error.assetId,
          file: file,
          onProcessing: function (asset) {
            updateStatus(tempUniqueId, controller.processingMessage ? controller.processingMessage(asset) : copy.processing);
          }
        });
      }

      var imageData = result && result.image_object;
      if (!imageData || !imageData.order) {
        var responseError = new Error(copy.failed);
        responseError.errorCode = 'UPLOAD_V2_IMAGE_OBJECT_MISSING';
        throw responseError;
      }
      imageData.original_file_name = imageData.original_file_name || file.name;
      uploadAttemptIds[imageData.order] = uploadAttemptId;
      document.querySelector('[data-unique-id="' + tempUniqueId + '"]')?.remove();
      StorageModule.appendDataToSessionStorage(imageData);
      TrackingModule.trackFileUploadComplete(imageData.file_name || file.name, uploadAttemptId);
      UIHelpers.upload_success_function(imageData);
      if (!$('.form__wrapper .bottom__part .step__one>.inn>.regular-btn').data('src')) {
        UIModule.setSelectedStepOneImage(imageData.order);
      }
      emit('file_upload_v2_modal_completed', {
        upload_pipeline: 'upload_v2',
        upload_attempt_id: uploadAttemptId,
        upload_asset_id: result.asset_id || ''
      });
      delete uploadAttemptIds[imageData.order];
    } catch (error) {
      var pendingPreview = document.querySelector('[data-unique-id="' + tempUniqueId + '"]');
      if (controller.isSelectionCancelled && controller.isSelectionCancelled(error)) {
        controller.discardUploadPreview(pendingPreview);
        return true;
      }
      pendingPreview?.remove();
      if (isQuotaLimit(error)) {
        handleQuotaLimit(error, uploadAttemptId);
        return true;
      }
      ErrorPopupModule.showError(error && error.message || copy.failed, error && error.helpLink);
      emit('file_upload_failed', {
        upload_pipeline: 'upload_v2',
        upload_attempt_id: uploadAttemptId,
        upload_asset_id: error && error.assetId || '',
        failure_phase: 'upload_v2',
        request_id: error && error.uploadRequestId,
        endpoint_operation: error && error.uploadRequestOperation,
        error_code: error && (error.errorCode || error.code) || 'UPLOAD_V2_FAILED',
        status_code: error && (error.statusCode || error.status),
        error_message: error && error.message || copy.failed
      });
    }
    return true;
  }

  async function reviewWarning(validation, file) {
    if (validation.warning_type !== 'no_icc_profile') {
      if (validation.warning) WarningPopupModule.showWarning(validation.warning, validation.warning_link || null);
      return true;
    }
    try {
      await window.StackhouseUploadV2.acknowledgeUploadWarning(validation, { file: file });
      return true;
    } catch (error) {
      var input = document.querySelector('.form__wrapper .upload__photos>input');
      if (input) input.value = '';
      if (!window.StackhouseUploadV2.isSelectionCancelled(error)) ErrorPopupModule.showError(error.message, error.helpLink);
      return false;
    }
  }

  window.StackhouseModalUploadV2 = Object.freeze({ upload: upload, reviewWarning: reviewWarning });
})(window);
